var _path, _path2, _g, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 19H11V13C11 10.334 13 9 14.999 9H15.001C17 9 19 10.334 19 13V19ZM16 22C16 22.552 15.552 23 15 23C14.448 23 14 22.552 14 22V21H16V22ZM21 18V13C21 9.447 18.632 7.475 16 7.079V5L14 5V7.079C11.368 7.475 9 9.447 9 13V18C9 18.552 8.552 19 8 19C7.448 19 7 19.448 7 20C7 20.552 7.448 21 8 21H12V22C12 23.657 13.343 25 15 25C16.657 25 18 23.657 18 22V21H22C22.552 21 23 20.552 23 20C23 19.448 22.552 19 22 19C21.448 19 21 18.552 21 18Z",
    fill: "#AAB5C5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22437_3126",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 5,
    width: 16,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 19H11V13C11 10.334 13 9 14.999 9H15.001C17 9 19 10.334 19 13V19ZM16 22C16 22.552 15.552 23 15 23C14.448 23 14 22.552 14 22V21H16V22ZM21 18V13C21 9.447 18.632 7.475 16 7.079V5L14 5V7.079C11.368 7.475 9 9.447 9 13V18C9 18.552 8.552 19 8 19C7.448 19 7 19.448 7 20C7 20.552 7.448 21 8 21H12V22C12 23.657 13.343 25 15 25C16.657 25 18 23.657 18 22V21H22C22.552 21 23 20.552 23 20C23 19.448 22.552 19 22 19C21.448 19 21 18.552 21 18Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22437_3126)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 24,
    height: 24,
    fill: "#668A90"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 6,
    r: 6,
    fill: "#EE4F4F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 6,
    r: 2,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.069b4c3c7b8ece1709bfb5be9b5dcbf9.svg";
export { ForwardRef as ReactComponent };